var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.name)?_c('div',[_c('div',[_c('div',{staticClass:"header text-center"},[_vm._v(_vm._s(_vm.name))])])]):_vm._e(),_vm._v(" "),_c('LibraryPermissionsWarning',{attrs:{"is_admin":_vm.is_admin}}),_vm._v(" "),_c('hr',{staticClass:"my-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }